import request from "@utils/request";

/**
 * 清除文件
 * @returns {*}
 */
export function clearFile(){
    return request.get("/sys/file/cleanFiles");
}

/**
 * 根据图片分类id查询分类下的图片库
 * @param data
 * @returns {*}
 */
export function getImagesByCategoryId(data){
    return request.post("/sys/image/category/getImagesByCategoryId",data);
}

/**
 * 根据附件id删除图片库的文件
 * @param id
 * @returns {*}
 */
export function deleteImageByFileId(id){
    return request.get("/sys/image/category/deleteImage?ids="+id);
}

/**
 * 更改图片库图片的分类
 * @param data
 * @returns {*}
 */
export function updateImage(data){
    return request.post("/sys/image/category/updateImageFileBusinessId",data);
}

/**
 * 用于商品轮播图选择，如若是修改之前选择的图片，则删除数据库数据，如若是新增的图片，就不用管
 * @param data
 * @returns {*}
 */
export function deleteBusinessImage(data){
    return request.post("/sys/file/deleteBusinessImage",data);
}
